<template>
    <div>
        <v-dialog v-model="dialog" max-width="500px">
            <div v-if="loading">
                <v-progress-linear indeterminate color="primary" />
            </div>
            <v-card v-else>
                <v-card-title class="headline flex-column pa-2">
                    <div class="d-flex fill-width">
                        <h2 class="flex-grow-1">{{$translate('Buy membership')}}</h2>
                        <v-btn icon @click="dialog = false" class="float-right"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <simple-product-list :products="membershipsToBuy" @buy="buy"
                                         buy-button-text="Choose" :useCheckoutButton="true"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SimpleProductList from '../views/SimpleProductList.vue'
export default {
    name: 'zoezi-buy-membership-dialog',

    props: ['value'],

    components: {
        SimpleProductList,
    },

    data: () => ({
        products: null,
        loading: false,
        items: [],
        unsubscribe: null
    }),

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        membershipsToBuy() {
            return this.products?.filter(x => x.membership);
        }
    },

    methods: {
        getProducts() {
            this.loading = true;
            this.$api.get('/api/public/trainingcard/type/get', { trial: true }).then(products => {
                this.products = products
                this.loading = false;
            });
        },
        buy() {
            this.dialog = false;
        }
    },
    mounted() {
        this.getProducts();
        this.unsubscribe = this.$root.$api.subscribe({type: 'trainingcardtype', callback: () => this.getProducts()})
    },

    destroyed() {
        this.unsubscribe?.();
    }
}
</script>
